import { callExternalApi } from "./external-api.service";

const tlogApiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;

export const getFixturesResource = async (event) => {
  const config = {
    url: `${tlogApiServerUrl}/api/fixtures/${event || ''}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};
